<template>
  <div>
    <nav class="border-b border-gray-300 py-2 px-2 md:px-0 ">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <span>splash pages</span>
          </div>
          <div class="text-xl text-primary">
            Splash pages
          </div>
        </div>
        <div class="" v-if="$store.getters.can('create_splash_pages')">
          <router-link
              class="py-1 px-2 md:py-2 md:px-4 bg-teal-500 md:font-semibold text-white hover:border-transparent rounded float-right"
              :to="{name:'create_splash_page'}">
            New page
          </router-link>
        </div>
      </div>
    </nav>
    <div class="py-4">
      <Notification/>
      <div class="">
        <SplashPagesComponent/>
      </div>
    </div>
  </div>
</template>

<script>
import SplashPagesComponent from "../../components/SplashPagesComponent";
import Notification from "../home/Notification";

export default {
  name: "SplashPages",
  components: {Notification, SplashPagesComponent},
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped>

</style>